var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _c("label", [_vm._v(_vm._s(_vm.column.label))]),
        _vm.loaded
          ? _c(
              "q-field",
              [
                _vm.value.label
                  ? _c(
                      "q-chip",
                      {
                        staticClass: "on-right",
                        attrs: {
                          closable: "",
                          color: "primary",
                          detail: "",
                          icon: "person",
                          square: ""
                        },
                        on: { close: _vm.handleClose }
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(_vm.value.label) + "\n      "
                        )
                      ]
                    )
                  : _c(
                      "q-search",
                      {
                        attrs: {
                          "stack-label": _vm.column.label,
                          placeholder: ""
                        },
                        model: {
                          value: _vm.term,
                          callback: function($$v) {
                            _vm.term = $$v
                          },
                          expression: "term"
                        }
                      },
                      [
                        _c("q-autocomplete", {
                          attrs: { placeholder: "", "min-characters": 1 },
                          on: { search: _vm.search, selected: _vm.selected }
                        })
                      ],
                      1
                    )
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }